import { Component } from "@angular/core";
import {
  ApplicationStatusObject,
  EUserType,
  IApplicantInfo,
  routeList,
} from "../shared/models";
import { Subject } from "rxjs";
import { AuthService } from "../shared/auth/auth.service";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { AcademicInfoService } from "../shared/services/api/academic-info.service";
import { environment } from "src/environments/environment";
import { commonEnv } from "src/environments/environment.common";
import { ApplicantInfoService } from "../shared/services/api/applicant-info.service";
import { ApplicantInfoStoreService } from "../services-store/applicant-info-store.service";
import { CommonModule } from "@angular/common";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";

@Component({
    selector: "app-complete",
    imports: [CommonModule, MatCardModule, MatButtonModule],
    templateUrl: "./complete.component.html",
    styleUrl: "./complete.component.scss"
})
export class CompleteComponent {
  public userType: EUserType;
  public userTypeEnum = EUserType;
  appId: IApplicantInfo["appId"];
  public showAutoEvalButton = false;
  applicationId: string = null;
  applicationStatusObject = ApplicationStatusObject;
  destroyed$ = new Subject();
  public aeSubmitted = false;
  guid: string = null;
  autoEvalUrl: string = null;
  isDisabled: boolean = false;
  public userPressedAutoEval = false;
  constructor(
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: AcademicInfoService,
    private applicantInfoService: ApplicantInfoService,
    private applicantInfoStoreService: ApplicantInfoStoreService,
    private http: HttpClient // private gtmService: GoogleTagManagerService
  ) {
    this.setUserInfo();
    // this.router.events.forEach(item => {
    //   if(item instanceof NavigationEnd) {
    //     const gtmTag = {
    //       event: 'page',
    //       pageName: item.url
    //     };

    //     this.gtmService.pushTag(gtmTag);
    //   }
    // })
    this.autoEvalUrl = environment.autoEvalUrl;
  }

  ngOnInit() {
    this.autoEvalUrl = environment.autoEvalUrl;
    this.applicationId =
      this.applicantInfoStoreService?.applicantInfo?.appId || "";

    this.service
      .checkIfApplicantProgramConfig(this.applicationId)
      .subscribe((data: Object) => {
        if (data) {
          this.showAutoEvalButton = true;
        }
      });

    this.service
      .checkIfAESubmitted(this.applicationId)
      .subscribe((data: Object) => {
        if (data) {
          this.aeSubmitted = true;
        }
      });
  }

  /*
Use clicked checkbox and wants to do autoEval
 */
  userWantsAE() {
    this.service
      .setAutoEval(this.applicationId)
      .subscribe((data: { message: string }) => {
        if (data) {
          this.guid = data.message;

          //show URL after clicking
          this.userPressedAutoEval = true;
          this.isDisabled = true;
        }
      });
  }

  setUserInfo = () => {
    if (
      this.authService.getUserInfo().tfp === commonEnv.applicantSignInPolicy
    ) {
      this.userType = EUserType.Applicant;
    } else if (
      this.authService.getUserInfo().tfp === commonEnv.agentSignInPolicy
    ) {
      this.userType = EUserType.Agent;
    }

    this.appId = this.activatedRoute.snapshot.queryParams["appId"];
  };

  isApplicant = () =>
    this.authService.getUserInfo().tfp === commonEnv.applicantSignInPolicy;

  onClose() {
    this.authService.logout();
  }

  onBack() {
    if (this.userType === EUserType.Applicant) {
      // the LoadApplicantInfo action will force to pull latest app status from database

      this.applicantInfoService.getApplicantInfo(this.applicationId);
      this.router.navigate([
        `/${routeList.application.path}/${routeList.application.children.review}`,
      ]);
    } else if (this.userType === EUserType.Agent) {
      this.router.navigate([
        `/${routeList.agent.path}/${routeList.agent.children.applicationList}`,
      ]);
    }
  }
}
